import {Component, HostListener, ViewChild} from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import {
  GET_USER_MEMBER_CLASS,
  MESSAGE_BOARD_THREADS_COUNT,
  MESSAGE_BOARD_THREADS_LIST,
} from 'manager/http-constants';
import { Table } from 'primeng/table';
import { DICVALUES_API_CONSTANT } from 'src/app/shared/constant/api-constant';
import {CONSTANT, DEFAULT_PAGINATION_EVENT, NUMBER} from 'src/app/shared/constant/constant';
import { LoadingState } from 'src/app/shared/html-parts/loading/loading-state';
import { CommonService } from 'src/app/shared/service/common.service';
import { DbOperationService } from 'src/app/shared/service/db-operation.service';
import { PlatformComponent } from '../platform.component';
import { FollowDialogComponent } from 'src/app/pages/platform/common/follow-dialog/follow-dialog.component';
import { LoginService } from 'src/app/shared/service/login.service';
import { MESSAGE_CODE } from 'src/app/shared/constant/message-constant';
import { SESSION_KEY } from 'src/app/shared/constant/session-constants';
import { IssueDetailDialogComponent } from 'src/app/pages/platform/common/issue-detail-dialog/issue-detail-dialog.component';
import {Title} from '@angular/platform-browser';

@Component({
  selector: 'app-l101',
  templateUrl: './l101.component.html',
  styleUrls: ['./l101.component.scss', '../platform.component.scss'],
})

/**
 * 掲示板スレッド一覧
 */
export class L101Component extends PlatformComponent {
  @ViewChild(FollowDialogComponent)
  followDialogComponent: FollowDialogComponent;
  @ViewChild(IssueDetailDialogComponent)
  issueDetailDialogComponent: IssueDetailDialogComponent;

  // 画面.検索フォーム
  l101SearchForm: FormGroup = this.formBuilder.group({
    // フリーワード検索
    freeword: CONSTANT.EMPTY_STRING,
    member_id: this.loginUser ? this.loginUser.member_id : '0'
  });

  /** テーブル状態 */
  @ViewChild('table') table: Table;

  // 課題・ソリューション結果リスト
  resultThreadDataList: object[] = [];

  // 課題・ソリューション結果リストトータル
  totalRecords = 0;

  // 課題・ソリューション件数格納先
  countThreadData = 0;

  // セッション保存名
  sessionTagName = 'l101SearchConditions';

  // ソート順
  sortOptions = [
    {label: '新しい順', value: '!update_datetime'},
    {label: 'アクセス数順', value: '!views'}
  ];
  // ソート降順昇順設定
  sortOrder: number;
  // ソート項目
  sortField: string;
  // ソート初期値
  sortKey: string;

  activeDropdownIndex: number | null = null;
  memberClassId = 0;

  constructor(
    public route: ActivatedRoute,
    public commonService: CommonService,
    public dbOperationService: DbOperationService,
    public loadingState: LoadingState,
    private router: Router,
    private formBuilder: FormBuilder,
    private loginService: LoginService,
    private titleService: Title
  ) {
    super(route, commonService, dbOperationService, loadingState);
    this.titleService.setTitle('地方創生SDGs官民連携マッチングシステム｜内閣府');
  }

  // tslint:disable-next-line:use-lifecycle-interface
  ngOnInit(): void {
    // 辞書値リストを取得
    this.getSpecCodeList(1, 2, 3);

    this.loginService.getAuth0LoginState().subscribe((response) => {
      // ログイン状態をセット

      // ログイン状態を判定
      if (response) {
        // ログイン状態の場合

        /* ログインユーザー情報 */
        // セッションからログインユーザ情報取得
        const loginUser = JSON.parse(
          window.sessionStorage.getItem(SESSION_KEY.loginUserInformation)
        );

        // セッションにログインユーザ情報が存在するか否か
        if (loginUser) {
          // セッションにログインユーザが存在する場合

          // 課題・ソリューション結果を取得
          console.log('セッションにログインユーザが存在する場合');
          this.checkMemberClass();
          this.getResultThreadDataList(false);
          return;
        } else {
          // セッションにログインユーザが存在しない場合(初回表示時)

          // ログインユーザ情報取得処理
          this.loginService.getLoginUser().subscribe((res) => {
            // 正常なユーザの為、セッションにユーザ情報を格納
            window.sessionStorage.setItem(
              SESSION_KEY.loginUserInformation,
              JSON.stringify(res.body[0])
            );

            this.loginUser = JSON.parse(window.sessionStorage.getItem(SESSION_KEY.loginUserInformation));
            this.l101SearchForm.get('member_id').setValue(this.loginUser.member_id);
            // 課題・ソリューション結果を取得
            console.log('セッションにログインユーザが存在しない場合(初回表示時)');
            this.checkMemberClass();
            this.getResultThreadDataList(false);
            return;
          });
        }
      } else {
        // 未ログイン状態の場合
        console.log('未ログイン状態の場合');

        this.loginUser = null;
        this.memberClassId = 0;

        this.getResultThreadDataList(false);
        return;
      }
    });

    // 代行会員情報を初期化
    this.initAltUserBySecretariat();

    // ソート順を設定
    this.sortKey = this.sortOptions[0].value;
    this.triggerInitialSort();
  }
  /**
   * 課題・ソリューション結果を取得
   */
  public getResultThreadDataList(screenSearchFlg: boolean, event: any = DEFAULT_PAGINATION_EVENT): void {
    // 画面.検索フォームから検索条件を取得
    // ※値渡し
    let l101SearchForm: any = JSON.parse(
      JSON.stringify(this.l101SearchForm.value)
    );

    const pageNo = event.first / event.rows + 1;
    const pageSize = event.rows;

    l101SearchForm.page_no = pageNo;
    l101SearchForm.page_size = pageSize;

    // 検索フォームが空の場合、セッションに保持している検索条件を設定
    if (!this.checkSetConditions(l101SearchForm) && !screenSearchFlg) {
      const sessionSearchForm = JSON.parse(sessionStorage.getItem(this.sessionTagName));
      // セッションに値がなければ設定しない
      if (this.checkSetConditions(sessionSearchForm)) {
        if (!this.loginUser){
          sessionSearchForm.member_id = '0';
        }else{
          sessionSearchForm.member_id = this.loginUser.member_id;
        }
        // 画面の検索条件に反映する
        this.l101SearchForm.setValue(sessionSearchForm);
        // 検索条件に設定する
        l101SearchForm = JSON.parse(
          JSON.stringify(this.l101SearchForm.value)
        );
      }
    }

    // 画面ロードフラグをON(ロード中状態)
    this.loadingState.loadStart(MESSAGE_BOARD_THREADS_COUNT);

    // 課題・ソリューション件数を取得
    this.dbOperationService
      .getNoTemplateData(MESSAGE_BOARD_THREADS_COUNT, null, true)
      .subscribe((response) => {
        // 課題・ソリューション件数を格納
        this.countThreadData = response.body.count;

        // 画面ロードフラグをOFF(ロード終了)
        this.loadingState.loadSleepEnd(0.3, MESSAGE_BOARD_THREADS_COUNT);
      });

    // 画面ロードフラグをON(ロード中状態)
    this.loadingState.loadStart(MESSAGE_BOARD_THREADS_LIST);

    // 課題・ソリューション一覧を取得
    this.dbOperationService
      .getNoTemplateData(MESSAGE_BOARD_THREADS_LIST, l101SearchForm, true)
      .subscribe((response) => {
        if (!this.commonService.checkNoneResponse(response)) {
          // 課題・ソリューション結果を格納
          this.resultThreadDataList = response.body.records;
          this.totalRecords = response.body.total_records;

          this.triggerInitialSort();
        } else {
          this.resultThreadDataList = [];
        }
        // 検索条件を保持
        sessionStorage.setItem(this.sessionTagName, JSON.stringify(this.l101SearchForm.value));

        // 画面ロードフラグをOFF(ロード終了)
        this.loadingState.loadSleepEnd(0.3, MESSAGE_BOARD_THREADS_LIST);
      });

    // 検索時にページアンカーへ遷移
    if (screenSearchFlg) {
      this.jumpTop();
      // テーブル状態をリセットする
      this.table.first = 0;
    }
  }

  /**
   * Trigger the onSortChange method programmatically
   */
  private triggerInitialSort(): void {
    const sortEvent = { value: '!update_datetime' };
    this.onSortChange(sortEvent);
  }

  /**
   * ソート順の設定を一覧に反映する
   * @param event ソート変更イベント
   */
  public onSortChange(event: { value: string }): void {
    this.applySorting(event.value);
  }

  /**
   * ソート順設定
   * @param value ソートキー
   */
  public applySorting(value: string): void {
    if (!value.startsWith('!')) {
      return; // '!'がない場合はソート処理をしない
    }

    console.log(value);

    const sortKey = value.substring(1); // '!'を除外してソートキーを取得

    this.resultThreadDataList.sort((a, b) => {
      if (sortKey === 'update_datetime') {
        return this.compareValues(a['update_datetime'], b['update_datetime'], true);
      }

      if (sortKey === 'views') {
        const viewsComparison = this.compareValues(
          parseFloat(a['views']),
          parseFloat(b['views']),
          true
        );

        if (viewsComparison !== 0) {
          return viewsComparison;
        }

        return this.compareValues(a['update_datetime'], b['update_datetime'], true);
      }

      return 0; // 不明なソートキーの場合はソートしない
    });
  }

  /**
   * 値を比較してソート順を決定
   * @param a 比較対象の値1
   * @param b 比較対象の値2
   * @param isDescending 降順かどうか
   * @returns aがbより小さい場合は負の値、大きい場合は正の値、等しい場合は0
   */
  private compareValues(a: any, b: any, isDescending: boolean = false): number {
    if (a > b) {
      return isDescending ? -1 : 1;
    }
    if (a < b) {
      return isDescending ? 1 : -1;
    }
    return 0;
  }

  /**
   * カテゴリ中項目
   * @param event チェック状態
   * @param code 大項目コード
   * @param list チェック対象小項目リスト
   */
  public checkMediumCategory(event: any, code: string, list: any): void {
    // 画面.検索フォーム.カテゴリを取得
    const getList = this.l101SearchForm.get('category').value;

    // チェック状態の判定
    if (event.checked) {
      // チェック状態の場合

      // チェック対象小項目リストからコード値のみ取得
      const spCodeList = this.commonService.createArrayGetArrayObject(
        list,
        'value'
      );

      // チェック対象小項目リストが全てチェック状態の場合
      if (spCodeList.every((spCode) => getList.indexOf(spCode) !== -1)) {
        // 画面.検索フォーム.カテゴリに大項目コードを追加
        getList.push(code);

        // 画面.検索フォーム.カテゴリに設定
        this.l101SearchForm.get('category').setValue(getList);
      }
    } else {
      // 非チェック状態の場合

      // 画面.検索フォーム.カテゴリから大項目コードを削除
      this.l101SearchForm
        .get('category')
        .setValue(getList.filter((value) => value !== code));
    }
  }

  /**
   * 検索条件が設定されているかチェックする
   * @param conditions 条件
   * @returns boolean true:設定あり / false:未設定
   */
  public checkSetConditions(conditions: any): boolean {
    // 検索条件が存在するかチェック
    if (conditions === undefined || conditions === null) {
      return false;
    } else {
      // 検索条件が設定されているかチェック
      if (conditions.freeword) {
        return true;
      }
    }
    return false;
  }

  /**
   * reset searchform and set appropirate initial value
   */
  resetSearchForm(): void {
    this.l101SearchForm.reset();
    this.l101SearchForm.get('member_id').setValue(this.loginUser ? this.loginUser.member_id : '0');
  }

  getDisplayName(thread: any): string {
    const isAnonymous = parseInt(thread.is_anonymous, 10) === 1;
    if (isAnonymous) {
      switch (parseInt(thread.class_id, 10)) {
        case 1:
          return `${thread.class_name}（${thread.prefectures}）`;
        case 2:
        case 9:
          return `${thread.class_name}`;
        case 3:
          return `${thread.class_name}（${thread.industry_name}）`;
        default:
          return '';
      }
    }
    // Non-anonymous
    else {
      return `${thread.organization_name}`;
    }
  }

  /**
   * 会員種類をチェック
   */
  private checkMemberClass(): void {
    // 画面ロードフラグをON(ロード中状態)
    this.loadingState.loadStart(GET_USER_MEMBER_CLASS);

    // 掲示板スレッド詳細を取得
    this.dbOperationService
      .getNoTemplateData(GET_USER_MEMBER_CLASS + this.getLoginUserId(), {}, false)
      .subscribe((response) => {
        // 画面ロードフラグをOFF(ロード終了)
        this.loadingState.loadSleepEnd(0.3, GET_USER_MEMBER_CLASS);
        if (this.commonService.checkNoneResponse(response)) {
          return;
        } else {
          const res = response.body;
          this.memberClassId = res.class_id;
        }
      });
  }

}
